const upsertItem = (originalData, item, idKey = "id") => {
  const index = originalData.findIndex(
    (existingItem) => existingItem[idKey] === item[idKey]
  );

  if (index !== -1) {
    originalData.splice(index, 1, item);
  } else {
    originalData.push(item);
  }

  return originalData;
};

const deleteItem = (originalData, id, idKey = "id") => {
  return originalData.filter((obj) => obj[idKey] !== id);
};

const bulkItems = (originalData, items, idKey = "id") => {
  const itemMap = new Map(items.map((item) => [item[idKey], item]));

  let updatedData = originalData.map((existingItem) => {
    if (itemMap.has(existingItem[idKey])) {
      return { ...existingItem, ...itemMap.get(existingItem[idKey]) };
    }
    return existingItem;
  });

  const newItems = items.filter(
    (item) =>
      !originalData.some((existingItem) => existingItem[idKey] === item[idKey])
  );

  updatedData = [...updatedData, ...newItems];

  return updatedData;
};

export default {
  upsertItem,
  deleteItem,
  bulkItems,
};
